import * as React from 'react';

import type Liff from '@line/liff';

export const LiffContext = React.createContext<typeof Liff | null>(null);
